module.exports = __webpack_public_path__ + "img/medical_colour.74da4230.webp";